module.exports = __webpack_public_path__ + "img/logo1.f83bec11.png";